/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const SteveIo = require("@gluenetworks/steve_core_io");
const Renderer = require("./LinksRenderer");

class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super();
        this._gameEditor = context.gameEditor;
        this._triggerType = context.triggerType;
        this._logger = context.logger;
        this._modalUserFeedback = context.modelUserFeedback;
        this._parentModel = context.parentContext;
        this._value = value;
        this._renderer = new Renderer(this);
        this._steveIo = new SteveIo();
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (this._value) {
            this._value.on(
                "PropertiesUpdated",
                (this.updateComponent = this.updateComponent.bind(this))
            );
        }
    }

    _unregisterListeners() {
        if (this._value) {
            this._value.removeListener("PropertiesUpdated", this.updateComponent);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._steveIo = undefined;
        this._gameEditor = undefined;
        this._triggerType = undefined;
        this._logger = undefined;
        this._modalUserFeedback = undefined;
        this._parentModel = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }

    getValue() {
        return this.getLinks();
    }

    updateComponent() {
        this.emit("Links", this._value);
    }

    setLinks(newVal) {
        this._value = newVal;
        this.emit("Links", newVal);
    }

    getLinks() {
        return this._value;
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
}

module.exports = LinksComponent;
